import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from '../base-query';
import { serializeQueryArgs } from '../serialize-query-args';

export const CURRENT_COMPANY_INFO_TAGS = Object.freeze({
  GET: 'get_current_company_info',
});

export const currentCompanyInfoApiSlice = createApi({
  reducerPath: 'currentCompanyInfoApiSlice',
  baseQuery,
  tagTypes: Object.values(CURRENT_COMPANY_INFO_TAGS),
  endpoints: (builder) => ({
    getCurrentCompanyInfo: builder.query({
      query: ({ apiManager, params }) => apiManager.get(params),
      providesTags: [CURRENT_COMPANY_INFO_TAGS.GET],
    }),
    updateCurrentCompanyInfo: builder.mutation({
      query: ({ apiManager, ...rest }) => apiManager.update(rest),
      invalidatesTags: [CURRENT_COMPANY_INFO_TAGS.GET],
    }),
  }),
  serializeQueryArgs,
});

export const { useGetCurrentCompanyInfoQuery, useUpdateCurrentCompanyInfoMutation } = currentCompanyInfoApiSlice;
